<template>
    <div class="vh-100 vw-100 d-flex flex-column">
        <DefaultHeader :noMargin="true" />
        <DailyHistoryMap :date="date" />
    </div>
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DailyHistoryMap from './Sections/DailyHistoryMap.vue'

export default {
    props: ['date'],
    components: {
        DefaultHeader,
        DailyHistoryMap
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user
        }
    },
    mounted() {
        console.log(this.date);
        if (!this.currentUser) {
            this.$router.push('/')
        }
    }
}
</script>